export default __webpack_public_path__ + "static/media/faq-etf.0f6f1df4.png";